module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-row', {
    staticClass: "order_toolbar toolbar pad_left",
    attrs: {
      "span": 24
    }
  }, [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('div', {
    staticClass: "activityFormClass"
  }, [_c('p', {
    staticClass: "hdxsClass"
  }, [_vm._v("活动形式")]), _vm._v(" "), _c('el-tabs', {
    staticStyle: {
      "height": "200px"
    },
    attrs: {
      "tab-position": "left"
    },
    on: {
      "tab-click": _vm.handleCurrentChange
    },
    model: {
      value: (_vm.activityId),
      callback: function($$v) {
        _vm.activityId = $$v
      },
      expression: "activityId"
    }
  }, _vm._l((_vm.leftActivityFormList), function(item, index) {
    return _c('el-tab-pane', {
      key: index,
      attrs: {
        "label": item.ActivityFormName,
        "name": item.ActivityFormId,
        "data-actid": item.ActivityId
      }
    })
  }), 1)], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('el-col', {
    staticClass: "order_content main_container"
  }, [_c('section', {
    staticClass: "model_section",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 14
    }
  }, [_c('p', {
    staticClass: "model_top_title"
  }, [_vm._v(_vm._s(_vm.activitiesName))])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('div', {
    staticClass: "divBtn"
  }, [((_vm.activityId == 1 || _vm.activityId == 2 || _vm.activityId == 3 || _vm.activityId == 4) && !(_vm.isEdit == 2 || _vm.isEdit == 3)) ? _c('button', {
    staticClass: "redBackground",
    on: {
      "click": function($event) {
        return _vm.addRelatedBrand()
      }
    }
  }, [_vm._v(" 新增 ")]) : _vm._e(), _vm._v(" "), ((_vm.activityId == 5 || _vm.activityId == 6 || _vm.activityId == 7) && (_vm.dataList.length != 1 || _vm.dataList == null)) ? _c('button', {
    staticClass: "redBackground",
    on: {
      "click": function($event) {
        return _vm.addRelatedBrand()
      }
    }
  }, [_vm._v(" 新增 ")]) : _vm._e(), _vm._v(" "), (_vm.activityId == 8) ? _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.addRelatedBrand()
      }
    }
  }, [_vm._v("新增")]) : _vm._e(), _vm._v(" "), (_vm.activityId == 9) ? _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.addOneRobbery()
      }
    }
  }, [_vm._v("新增")]) : _vm._e()], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "table_container"
  }, [_c('div', {
    staticClass: "table_inner_container",
    staticStyle: {
      "height": "auto"
    }
  }, [_c('el-table', {
    staticClass: "invoice_tab",
    staticStyle: {
      "height": "auto"
    },
    attrs: {
      "data": _vm.dataList,
      "stripe": "",
      "border": ""
    }
  }, [_c('el-table-column', {
    key: "1",
    attrs: {
      "label": "序号",
      "align": "center",
      "width": "50"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.$index + 1))])]
      }
    }])
  }), _vm._v(" "), (_vm.activityId != 4) ? [(_vm.activityId == 1 || _vm.activityId == 2 || _vm.activityId == 3) ? _c('el-table-column', {
    attrs: {
      "label": "店铺",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "spanList",
          attrs: {
            "title": scope.row.brandName
          }
        }, [_vm._v(_vm._s(scope.row.brandName))])]
      }
    }], null, false, 3044227332)
  }) : _vm._e(), _vm._v(" "), (_vm.activityId == 1 || _vm.activityId == 2 || _vm.activityId == 3) ? _c('el-table-column', {
    attrs: {
      "label": "商品编码",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "spanList"
        }, [_vm._v(_vm._s(scope.row.goodModelCode))])]
      }
    }], null, false, 3063615215)
  }) : _vm._e(), _vm._v(" "), (_vm.activityId == 1 || _vm.activityId == 2 || _vm.activityId == 3) ? _c('el-table-column', {
    attrs: {
      "label": "商品名称",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "spanList"
        }, [_vm._v(_vm._s(scope.row.title))])]
      }
    }], null, false, 1442381006)
  }) : _vm._e(), _vm._v(" "), (_vm.activityId == 1 || _vm.activityId == 2 || _vm.activityId == 3) ? _c('el-table-column', {
    attrs: {
      "label": "市场价",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "spanList"
        }, [_vm._v(_vm._s(scope.row.marketPrice))])]
      }
    }], null, false, 4065500327)
  }) : _vm._e(), _vm._v(" "), (_vm.activityId == 5 || _vm.activityId == 6 || _vm.activityId == 7) ? _c('el-table-column', {
    attrs: {
      "label": "礼品名称",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "spanList"
        }, [_vm._v(_vm._s(scope.row.name))])]
      }
    }], null, false, 2318523081)
  }) : _vm._e(), _vm._v(" "), (_vm.activityId == 5 || _vm.activityId == 6 || _vm.activityId == 7) ? _c('el-table-column', {
    attrs: {
      "label": "礼品数量",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "spanList"
        }, [_vm._v(_vm._s(scope.row.number))])]
      }
    }], null, false, 1264468141)
  }) : _vm._e(), _vm._v(" "), (_vm.activityId == 5) ? _c('el-table-column', {
    attrs: {
      "label": "核销时间",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "spanList"
        }, [_vm._v(_vm._s(scope.row.datetime))])]
      }
    }], null, false, 2571745871)
  }) : _vm._e(), _vm._v(" "), (_vm.activityId == 8) ? _c('div', [_c('el-table-column', {
    attrs: {
      "label": "店铺",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.shopname))]
      }
    }], null, false, 2506930046)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "商品编码",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.goodscode))]
      }
    }], null, false, 2420543744)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "商品名称",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.goodsname))]
      }
    }], null, false, 3981461706)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "商品类型",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.goodstypename))]
      }
    }], null, false, 2347083602)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "状态",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.isonsalename))]
      }
    }], null, false, 116187098)
  })], 1) : _vm._e(), _vm._v(" "), (_vm.activityId == 9) ? _c('el-table-column', {
    attrs: {
      "label": "活动号码",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.smackercode))]
      }
    }], null, false, 3650483280)
  }) : _vm._e()] : [_c('el-table-column', {
    attrs: {
      "label": "优惠券名称",
      "prop": "name",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "spanList"
        }, [_vm._v(_vm._s(scope.row.name))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "面值",
      "prop": "facevalue",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "spanList"
        }, [_vm._v(_vm._s(scope.row.facevalue))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "使用条件",
      "prop": "usethreshold",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "spanList"
        }, [_vm._v(_vm._s(scope.row.usethreshold))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "售价",
      "prop": "price",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "spanList"
        }, [_vm._v(_vm._s(scope.row.price))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "适用店铺",
      "prop": "shopname",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "spanList"
        }, [_vm._v(_vm._s(scope.row.shopname))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "优惠券数量",
      "prop": "number",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "spanList"
        }, [_vm._v(_vm._s(scope.row.number))])]
      }
    }])
  })], _vm._v(" "), (_vm.activityId == 1) ? _c('el-table-column', {
    attrs: {
      "label": "促销价",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "spanList"
        }, [_vm._v(_vm._s(scope.row.promotionPrice))])]
      }
    }], null, false, 2177772080)
  }) : _vm._e(), _vm._v(" "), (_vm.activityId == 2) ? _c('el-table-column', {
    attrs: {
      "label": "秒杀价",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "spanList"
        }, [_vm._v(_vm._s(scope.row.seckillPrice))])]
      }
    }], null, false, 253295924)
  }) : _vm._e(), _vm._v(" "), (_vm.activityId == 2) ? _c('el-table-column', {
    attrs: {
      "label": "数量",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "spanList"
        }, [_vm._v(_vm._s(scope.row.seckillStock))])]
      }
    }], null, false, 2775004889)
  }) : _vm._e(), _vm._v(" "), (_vm.activityId == 3) ? _c('el-table-column', {
    attrs: {
      "label": "团购价",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "spanList"
        }, [_vm._v(_vm._s(scope.row.groupPrice))])]
      }
    }], null, false, 4118407772)
  }) : _vm._e(), _vm._v(" "), (_vm.activityId == 3) ? _c('el-table-column', {
    attrs: {
      "label": "成团人数",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "spanList"
        }, [_vm._v(_vm._s(scope.row.groupNumber))])]
      }
    }], null, false, 1707783666)
  }) : _vm._e(), _vm._v(" "), (_vm.activityId == 2 || _vm.activityId == 3) ? _c('el-table-column', {
    attrs: {
      "label": "佣金",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "spanList"
        }, [_vm._v(_vm._s(scope.row.commissionRate))])]
      }
    }], null, false, 1771408097)
  }) : _vm._e(), _vm._v(" "), (_vm.isEdit != 2) ? _c('el-table-column', {
    attrs: {
      "label": "操作",
      "fixed": "right",
      "width": "235",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(_vm.isEdit != 3 && _vm.activityId != 8 && _vm.activityId != 9) ? _c('span', {
          staticClass: "handle",
          on: {
            "click": function($event) {
              return _vm.editActivity(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-edit-outline"
        }), _vm._v(" 编辑\r\n                  ")]) : _vm._e(), _vm._v(" "), (_vm.isEdit != 3) ? _c('span', {
          staticClass: "handle",
          on: {
            "click": function($event) {
              return _vm.deleteBrand(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-delete"
        }), _vm._v(" 删除\r\n                  ")]) : _vm._e(), _vm._v(" "), (_vm.activityId == 9) ? _c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.$index > 0),
            expression: "scope.$index > 0"
          }],
          staticClass: "handle",
          on: {
            "click": function($event) {
              return _vm.spUpordown(scope.row, 1)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-upload2"
        }), _vm._v(" 向上\r\n                  ")]) : _vm._e(), _vm._v(" "), (_vm.activityId == 9) ? _c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.$index < _vm.dataList.length - 1),
            expression: "scope.$index < dataList.length - 1"
          }],
          staticClass: "handle",
          on: {
            "click": function($event) {
              return _vm.spUpordown(scope.row, 2)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-download"
        }), _vm._v(" 向下\r\n                  ")]) : _vm._e(), _vm._v(" "), (_vm.isEdit == 3) ? _c('span', {
          staticClass: "handle",
          on: {
            "click": function($event) {
              return _vm.seeinfo(scope.row, 3)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-view"
        }), _vm._v(" 查看\r\n                  ")]) : _vm._e()]
      }
    }], null, false, 2002097535)
  }) : _vm._e()], 2)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-left": "0",
      "margin": "22px auto",
      "text-align": "center"
    }
  }, [_c('button', {
    staticClass: "el-button el-button--default cancle normal_btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toPrevStep
    }
  }, [_vm._v("\r\n              上一步\r\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "el-button el-button--default search_btn normal_btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toNextStep
    }
  }, [_vm._v("\r\n              下一步\r\n            ")])])])])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "add_order_cancle",
    attrs: {
      "title": "共创推广优惠券佣金上限",
      "visible": _vm.isToExamine,
      "width": "30%"
    },
    on: {
      "update:visible": function($event) {
        _vm.isToExamine = $event
      }
    }
  }, [_c('el-form', [_c('el-form-item', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入共创推广优惠券佣金上限",
      "maxlength": "20"
    },
    model: {
      value: (_vm.upperLimit),
      callback: function($$v) {
        _vm.upperLimit = $$v
      },
      expression: "upperLimit"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-left": "0",
      "text-align": "center"
    }
  }, [_c('button', {
    staticClass: "el-button el-button--default cancle normal_btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.isToExamine = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('button', {
    staticClass: "el-button el-button--default search_btn normal_btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.editSubmit()
      }
    }
  }, [_vm._v("保存")])])], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "add_order_cancle",
    attrs: {
      "title": "幸运购",
      "visible": _vm.yiyuan,
      "width": "25%"
    },
    on: {
      "update:visible": function($event) {
        _vm.yiyuan = $event
      }
    }
  }, [_c('el-form', [_c('el-form-item', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入幸运购活动号码    例：230307001",
      "maxlength": "11"
    },
    model: {
      value: (_vm.yyqHdhm),
      callback: function($$v) {
        _vm.yyqHdhm = $$v
      },
      expression: "yyqHdhm"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "line-height": "10px",
      "padding": "0 0 10px 5px"
    }
  }, [_c('b', {
    staticStyle: {
      "color": "#F56C6C"
    }
  }, [_vm._v("温馨提示：")]), _vm._v(" "), _c('p', [_vm._v("如需添加幸运购活动号码，请联系400-1577-588。")])])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-left": "0",
      "text-align": "center"
    }
  }, [_c('button', {
    staticClass: "el-button el-button--default cancle normal_btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.yiyuan = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('button', {
    staticClass: "el-button el-button--default search_btn normal_btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.yyqSubmit()
      }
    }
  }, [_vm._v("保存")])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e69f6a26!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/addOrEditActive/activityFormList.vue
// module id = 1754
// module chunks = 3